// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"cfcabb55","147":"cfcabb55","224":"59dc8760","270":"a4047f0e","363":"86b2331f","433":"9400f8ba","478":"9400f8ba","744":"43417241"}[chunkId] + ".chunk.css";
};